"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableScrollControls = void 0;
var _react = _interopRequireWildcard(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useDebounce = require("use-debounce");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TableScrollControls = exports.TableScrollControls = function TableScrollControls(_ref) {
  var scrollingElement = _ref.scrollingElement,
    tableElement = _ref.tableElement,
    visiblePlans = _ref.visiblePlans;
  var leftScrollButton = (0, _react.useRef)(null);
  var rightScrollButton = (0, _react.useRef)(null);
  var tableScrollControls = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    scrollerPosition = _useState2[0],
    setScrollerPosition = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasHorizontalScroll = _useState4[0],
    setHasHorizontalScroll = _useState4[1];
  var AddListeners = (0, _react.useCallback)(function (_ref2) {
    var buttonElement = _ref2.buttonElement,
      scrollingElement = _ref2.scrollingElement,
      direction = _ref2.direction;
    var scrollStartEvents = ['mousedown', 'touchstart'];
    var StartScroll = function StartScroll(direction) {
      if (direction === 'left') {
        scrollingElement.scrollBy({
          left: -320,
          behavior: 'smooth'
        });
      } else {
        scrollingElement.scrollBy({
          left: 320,
          behavior: 'smooth'
        });
      }
    };
    scrollStartEvents.forEach(function (startEventType) {
      buttonElement.addEventListener(startEventType, function () {
        return StartScroll(direction);
      }, {
        passive: true
      });
    });
  }, []);
  AddListeners.propTypes = {
    buttonElement: _propTypes["default"].element,
    scrollingElement: _propTypes["default"].element,
    direction: _propTypes["default"].string
  };
  var CheckAndApplyScrollControls = (0, _useDebounce.useDebouncedCallback)(function () {
    var scrollingDomElement = scrollingElement.current;
    var scrollControlsDomElement = tableScrollControls.current;
    var leftScrollButtonDomElement = leftScrollButton.current;
    var rightScrollButtonDomElement = rightScrollButton.current;
    var tableDomElement = tableElement.current;
    if (scrollingDomElement && scrollControlsDomElement && leftScrollButtonDomElement && rightScrollButtonDomElement && tableDomElement) {
      var needsControls = scrollingDomElement.offsetWidth < tableDomElement.scrollWidth;
      setHasHorizontalScroll(needsControls);
      if (needsControls) {
        setScrollerPosition({
          left: scrollingDomElement.offsetLeft,
          top: scrollingDomElement.offsetTop
        });
        AddListeners({
          buttonElement: leftScrollButtonDomElement,
          scrollingElement: scrollingDomElement,
          direction: 'left'
        });
        AddListeners({
          buttonElement: rightScrollButtonDomElement,
          scrollingElement: scrollingDomElement,
          direction: 'right'
        });
      }
    }
  }, [AddListeners, scrollingElement, tableElement, tableScrollControls, leftScrollButton, rightScrollButton, setHasHorizontalScroll, setScrollerPosition]);
  (0, _react.useEffect)(function () {
    CheckAndApplyScrollControls();
    window.addEventListener('resize', function () {
      CheckAndApplyScrollControls();
    });
  }, [CheckAndApplyScrollControls, visiblePlans]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: tableScrollControls,
    className: "tableScrollControls ".concat(hasHorizontalScroll ? 'hasHorizontalScroll' : ''),
    role: "presentation",
    "aria-hidden": true
  }, /*#__PURE__*/_react["default"].createElement("button", {
    style: {
      left: scrollerPosition.left
    },
    ref: leftScrollButton,
    type: "button",
    className: "tableScrollControl left"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Hold down to scroll table to the left"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "caret_left"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    style: {
      right: scrollerPosition.left
    },
    ref: rightScrollButton,
    type: "button",
    className: "tableScrollControl right"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Hold down to scroll table to the right"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "caret_right"
  })));
};
TableScrollControls.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  scrollingElement: _propTypes["default"].object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  tableElement: _propTypes["default"].object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  visiblePlans: _propTypes["default"].any
};